import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "trim",
})
export class TrimPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const limit = args ?? 50;
    if (value.length < limit) {
      return value;
    }
    return value.toString().substring(0, limit - 3) + "...";
  }
}
